(function () {
    'use strict';

    angular.module('swif.framework')

    .factory('swifFrameworkCartService', swifFrameworkCartService);

    /**
    * @ngdoc service
    * @name swif.framework.swifFrameworkCartService
    * @requires swif.framework.settingsService
    * @requires swif.framework.dataService
    **/
    function swifFrameworkCartService($localStorage, settingsService, dataService) {
        'ngInject';
        var settings = settingsService;
        var service = {};
        var storage = $localStorage.$default({
            cart: {}
        });
        service.cart = storage.cart;
        service.info = {};
        service.active = false;
        settings.initialize().then(function (settings) {
            service.active = settings.app.features.cart;
            if (_.isUndefined(service.active)) {
                service.active = true;
            }
        });
        service.updateTotal = function () {
            service.info.items_length = 0;
            _.forEach(service.cart, function (items) {
                service.info.items_length += items.length;
            });
        };
        service.initCartType = function (type) {
            if (!service.cart[type]) {
                service.cart[type] = [];
            }
            return service.cart[type];
        };
        service.updateTotal();
        service.addToCart = function (item) {
            if (!service.active) {return;}
            if (_.isArray(item)) {
                //concat + uniq
                if (item.length > 0) {
                    var type = item[0]._type;
                    var cartItems = service.initCartType(type);
                    var concatenated = cartItems.concat(item);
                    var uniq = _.uniq(concatenated, function (item) {
                        return item.id;
                    });
                    dataService.replaceObj(cartItems, uniq);
                }
            } else if (item._type) {
                if (!service.cart[item._type]) {
                    service.cart[item._type] = [];
                }
                if (!service.hasCartItem(item)) {
                    service.cart[item._type].push({
                        _type: item._type,
                        name: item.name,
                        complete_name: item.complete_name,
                        id: item.id
                    });
                }
            }
            service.updateTotal();
        };

        service.hasCartItem = function (item) {
            var hasCartItem = false;
            if (item) {
                _.forEach(service.cart[item._type], function (i) {
                    if (i.id === item.id) {
                        hasCartItem = true;
                    }
                });
            }
            return hasCartItem;
        };
        service.getCartItem = function (item) {
            var cartItem;
            _.forEach(service.cart[item._type], function (i) {
                if (i.id === item.id) {
                    cartItem = i;
                }
            });
            return cartItem;
        };
        service.rmFromCart = function (item) {
            if (!service.active) {return;}
            var cartItem = service.getCartItem(item);
            if (cartItem) {
                _.pull(service.cart[item._type], cartItem);
                service.updateTotal();
            }
        };
        service.getCartItems = function (type) {
            var cartItems = [];
            if (!service.active) {return [];}
            if (type) {
                if (!service.cart[type]) {
                    service.cart[type] = [];
                }
                cartItems = service.cart[type];
            }
            return cartItems;
        };

        //TODO : remplacer cette méthode par un _.pluck ?
        service.getCartItemsIds = function (type) {
            var ids = [];
            var items = service.getCartItems(type);
            _.forEach(items, function (item) {
                ids.push(item.id);
            });
            return ids;
        };

        service.onDelete = [];
        function onDelete (type) {
            _.forEach(service.onDelete, function (hook) {
                hook(type);
            });
        }
        service.emptyCart = function (type) {
            if (type) {
                onDelete(type);
                delete service.cart[type];
            } else {
                _.forOwn(service.cart, function (value, key) {
                    onDelete(key);
                    delete service.cart[key];
                });
            }
            service.updateTotal();
        };
        return service;
    }

})();
